import { useEffect, useState } from "react";
import { useLang } from "@/i18n";
import { useSEO } from "@/hooks/useSEO";
import { loadRooms } from "@/data/roomStore";
import RoomCard from "@/components/RoomCard";
import { ChapterHeading } from "@/components/Reveal";

export default function StaysPage() {
    const { t } = useLang();
    const [roomList, setRoomList] = useState([]);
    useSEO(t.stays.title, t.stays.desc);
    useEffect(() => {
        loadRooms().then(setRoomList).catch(() => {});
    }, []);
    return (
        <div className="pt-28 pb-24 md:pt-36 md:pb-32" data-testid="stays-page">
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
                    <ChapterHeading label={t.stays.label} title={<>{t.stays.titleA} <em className="text-olive">{t.stays.titleEm}</em></>} />
                    <p className="max-w-sm text-sm font-light leading-relaxed text-ink-muted md:text-base">{t.stays.intro}</p>
                </div>
                <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                    {roomList.map((room, i) => (
                        <RoomCard key={room.slug} room={room} index={i} wide={false} />
                    ))}
                </div>
            </div>
        </div>
    );
}
